export enum TransactionMode {
  Normal = 0, // 普通模式
  Deposit = 1, // 入金
  Withdraw = 2, // 出金
  TransferIn = 3, // 转入
  TransferOut = 4, // 转出
  All = 9, // 全部（慎用）
}
